/**
 * 旅程の日数に応じたタグラベル（旅程ページ内で共通利用）
 * 3日以下: Short Stay / 4日以上: Multi-Day Journey
 */
export const ITINERARY_TAG_LABEL_SHORT_STAY = 'Private Tailored Short Stay';
export const ITINERARY_TAG_LABEL_MULTI_DAY = 'Private Tailored Multi-Day Journey';

/** 日数未設定時に表示するデフォルトタグラベル */
export const DEFAULT_ITINERARY_TAG_LABEL = 'A Journey Designed for You';

/** Short Stay とみなす日数の閾値（この値以下が Short Stay） */
export const ITINERARY_TAG_DAYS_THRESHOLD = 3;

/**
 * 旅程の日数から表示用タグラベルを返す
 * @param days - 旅程の日数（itineraryTagSettings.days）
 * @returns タグ文字列。days が未設定の場合は undefined
 */
export const getItineraryTagLabel = (days: number | undefined): string | undefined => {
  if (days === undefined) return undefined;
  return days <= ITINERARY_TAG_DAYS_THRESHOLD ? ITINERARY_TAG_LABEL_SHORT_STAY : ITINERARY_TAG_LABEL_MULTI_DAY;
};
